var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-tabs", {
    attrs: {
      type: "border-card"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "Info"
    }
  }, [_c("ledger-info-tab", {
    attrs: {
      data: _vm.ledgerInfoData
    },
    on: {
      refresh: _vm.getLedgerInfo
    }
  })], 1), _c("el-tab-pane", {
    attrs: {
      label: "Products"
    }
  }, [_c("ledger-product-tab", {
    attrs: {
      data: _vm.ledgerInfoData
    }
  })], 1), _c("el-tab-pane", {
    attrs: {
      label: "Dealer"
    }
  }, [_c("ledger-user-tab", {
    attrs: {
      data: _vm.ledgerInfoData
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };